import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "FAQsList",
    component: () => (__SERVER__ ? require("./faqs-list-view") : import("./faqs-list-view"))
});

export default definition;
